import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IconButton, Paper, Stack, Typography, styled } from '@mui/material';

import { Experiences } from '@luxuryescapes/contract-svc-experience';

import { currencyFormatter } from '../../../helpers';

interface SortableListItemProps {
  value: Experiences.Offer;
  removeOnclick: (value: Experiences.Offer) => void;
}

const InfoTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
}));

export function HeroesListItem({ value, removeOnclick }: SortableListItemProps) {
  const { attributes, listeners, setNodeRef, transition, transform } = useSortable({
    id: value.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Paper variant="outlined" ref={setNodeRef} style={style} {...attributes}>
      <Stack direction="row" padding={1} justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1}>
          <IconButton {...listeners} tabIndex={-1} style={{ cursor: 'grab', borderRadius: 0 }} size="small" disabled>
            <DragIndicatorIcon />
          </IconButton>
          <Stack direction="column" spacing={2}>
            <Typography>{value.title}</Typography>

            <Stack direction="row" spacing={2}>
              <InfoTypography>{value.provider}</InfoTypography>
              <InfoTypography>{currencyFormatter(value.pricing.currency, value.pricing.salesPrice)}</InfoTypography>
              {!!value.score && <InfoTypography>MPV {value.score}</InfoTypography>}
            </Stack>
          </Stack>
        </Stack>
        <IconButton title="Remove" onClick={() => removeOnclick(value)}>
          <DeleteIcon />
        </IconButton>
      </Stack>
    </Paper>
  );
}
